const searchArticles = async (lang, country, query) => {
    const url = `/api/zendesk/articles/search?lang=${lang}&country=${country}&query=${query}`;
    const resp = await fetch(url, { method: 'GET' });

    if (resp.status === 200) {
        const json = await resp.json();
        return json;
    }

    return [];
};

export const getArticles = async (lang, country, query, sections) => {
    const articles = await searchArticles(lang, country, query);

    if (articles) {
        return articles.map((article) => {
            const section = sections.find((s) => s.id === article.section_id);
            return {
                id: article.id,
                title: article.title,
                section_id: article.section_id,
                category_id: section.category_id,
                directLink: article.label_names?.includes('directLink') || section.directLink,
            };
        });
    }

    return null;
};
